module.exports = __webpack_public_path__ + "static/media/ideco-footer.56b2c1cb.svg";